"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourExecutionDetail = void 0;
var BehaviourNodeExecution_1 = require("./BehaviourNodeExecution");
/**
 * Represents a detailed summary of executed entities to a given processInstanceId
 */
var BehaviourExecutionDetail = /** @class */ (function (_super) {
    __extends(BehaviourExecutionDetail, _super);
    function BehaviourExecutionDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BehaviourExecutionDetail";
        _this.processInstanceId = function () {
            _this.push(function (_) { return "processInstanceId"; });
        };
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.qualifier = function () {
            _this.push(function (_) { return "qualifier"; });
        };
        _this.behaviours = function () {
            _this.push(function (_) { return "behaviours"; });
        };
        _this.behaviourId = function () {
            _this.push(function (_) { return "behaviourId"; });
        };
        _this.nodes = function (config) { return _this.push(function (registry) {
            var entity = new BehaviourNodeExecution_1.BehaviourNodeExecution();
            config(entity);
            return "nodes { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BehaviourExecutionDetail;
}(Array));
exports.BehaviourExecutionDetail = BehaviourExecutionDetail;
//# sourceMappingURL=BehaviourExecutionDetail.js.map